import React from "react";
import "aos/dist/aos.css";

const BookWithUsCards = ({ heading, paragraph, Icon }) => {
  return (
    <div
      // data-aos="fade-up"
      className="px-auto py-3 bg-white mx-5 md:mx-5 lg:mx-3 xl:mx-3 sm:mx-40 lg:w-60 xl:w-72"
    >
      <div>
        {/* icons */}
        <div className="flex flex-wrap justify-center">
          <Icon className="w-14 h-14 text-secondary" />
        </div>
        <div className="space-y-1">
          {/* heading */}
          <div className="font-sans text-lg text-center text-black font-semibold md:text-base lg:text-base 2xl:text-lg my-3">
            {heading}
          </div>

          {/* paragraph */}
          <div className="font-body text-xs text-center text-[#606060] md:text-sm">
            {paragraph}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookWithUsCards;
